import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import { routes } from '#routes';

export type ChatroomStatsResponse = paths['/chatrooms/stats']['get']['responses']['200']['content']['application/json'];

export const getChatroomStats = async () =>
  getNodeApiAxiosInstance().get<ChatroomStatsResponse, AxiosResponse<ChatroomStatsResponse>>(routes.chatrooms.stats);
